export namespace Links {
    export const TERMS_OF_SERVICE = "https://docs.google.com/document/d/1ADa4cqyyv6kZRBu4bHC1CvfNxGd8KaTdHQaCYVlZWfg/edit?usp=sharing"
    export const PRIVACY_POLICY =  "https://docs.google.com/document/d/1qciVUlpEBy3Pzk7LQfCNo_VKVw1xymsOAGgz71yoF14/edit?usp=sharing"
    export const APP_STORE = "https://apps.apple.com/id/app/id6446815915"
    export const PLAY_STORE = "https://play.google.com/store/apps/details?id=com.beaconTags"
}